import React, { useState, useEffect } from "react";
import { producaov2 as api } from "../../../services/apis";
import { Icon, Loader } from "semantic-ui-react";
import {
  Container,
  Content,
  Title,
  ContainerInputSearch,
  Input,
  CreateButton,
  Cards,
} from "./styles";
import swal from "sweetalert";
import { withRouter } from "react-router-dom";
import AdminMenu from "../../../components/Admin/MenuDetalhes/AdminMenu";
import Card from "./Card";
import { isAuthAdmin } from "../../../services/auth";

const Logs = (props) => {
  const [logs, setLogs] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    loadAuth();
    loadLogs();
  }, []);
  const loadAuth = async () => {
    const auth = await isAuthAdmin();

    if (!auth) {
      localStorage.setItem("redirect", `/admin/`);
      window.location.href = "/login";
      return null;
    }
  };

  const loadLogs = () => {
    api
      .get("/system_logs")
      .then(async (res) => {
        const newLogs = modifyLogs(res.data);

        newLogs.sort((a, b) =>
          a.nome > b.nome ? 1 : a.nome < b.nome ? -1 : 0
        );

        console.log("NEW LOGS", newLogs);

        setLogs(newLogs);
        let logs = { local: "logs", texto: `listou os logs` };
        await api.post("system_logs", { acao: JSON.stringify(logs) });
        setLoading(false);
      })
      .catch((err) => {
        swal("Não foi possível carregar os logs", err, "");
      });
  };
  const verifyImage = (value) => {
    if (value == null || value.foto == "") {
      return "https://www.voitto.com.br/assets/images/user_default.png";
    }

    return value.foto;
  };

  const modifyLogs = (logs) => {
    let newLogs = logs;
    let value = [];
    while (newLogs.length != 0) {
      let modify = newLogs.filter(
        (array) => array.id_user == newLogs[0].id_user
      );
      newLogs = newLogs.filter((array) => array.id_user != newLogs[0].id_user);
      value = [
        ...value,
        {
          id_user: modify[0].id_user,
          nome: modify[0].nome,
          foto: verifyImage(modify[0].pessoa),
          menssage: modify.map((value) => ({
            data: value.date,
            menssage: value.acao,
          })),
        },
      ];
    }
    return value;
  };

  return (
    <>
      <Container>
        <AdminMenu />

        {loading ? (
          <Loader active inline="centered" size="massive" />
        ) : (
          <Content>
            <Title>Logs de Ações</Title>

            <ContainerInputSearch className="ui fluid left icon input">
              <Input
                type="search"
                placeholder="Procurar por nome..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
              <Icon name="search icon" />
            </ContainerInputSearch>

            {logs.length > 0 ? (
              <Cards>
                {logs
                  .filter((log) =>
                    log.nome.toLowerCase().includes(search.toLowerCase())
                  )
                  .map((log, index) => (
                    <Card
                      key={index}
                      nome={log.nome}
                      img={log.foto}
                      menssage={log.menssage}
                    />
                  ))}
              </Cards>
            ) : (
              <h1>Nenhum Log foi encontrado</h1>
            )}
          </Content>
        )}
      </Container>
    </>
  );
};

export default withRouter(Logs);
